import { useMedia } from 'react-use';

const useMediaQuery = (options = {}) => {
  const { maxWidth = 725 } = options;

  return useMedia(`(max-width: ${maxWidth}px)`);
};

export default useMediaQuery;
